import { render, staticRenderFns } from "./CodeHighlightedBlock.vue?vue&type=template&id=ed1470d2&lang=pug"
import script from "./CodeHighlightedBlock.vue?vue&type=script&lang=ts"
export * from "./CodeHighlightedBlock.vue?vue&type=script&lang=ts"
import style0 from "./CodeHighlightedBlock.vue?vue&type=style&index=0&id=ed1470d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
